module.exports = __webpack_public_path__ + "img/danamon_online.2375a1fb.svg";